import "/home/runner/work/pocket-dimension-dice/pocket-dimension-dice/components/CustomDiceRoller/components/Roller/styles.module_built.css";
const classes = {"gear":"ogfxNa_gear","settingsButtonContainer":"ogfxNa_settingsButtonContainer","wrapper":"ogfxNa_wrapper","d20":"ogfxNa_d20","d4":"ogfxNa_d4","rollToActive":"ogfxNa_rollToActive","shared3dDiceImageDisabled":"ogfxNa_shared3dDiceImageDisabled","diceTextContainer":"ogfxNa_diceTextContainer","rollToButton":"ogfxNa_rollToButton","refreshText":"ogfxNa_refreshText","shared3dDiceImage":"ogfxNa_shared3dDiceImage","shared3dDiceImageWrapper":"ogfxNa_shared3dDiceImageWrapper","rollButton":"ogfxNa_rollButton","rollToContainer":"ogfxNa_rollToContainer","rollToWrapper":"ogfxNa_rollToWrapper","die":"ogfxNa_die","d100":"ogfxNa_d100","changeDiceSetLink":"ogfxNa_changeDiceSetLink","shared3dDiceContainer":"ogfxNa_shared3dDiceContainer","diceContainer":"ogfxNa_diceContainer","dice":"ogfxNa_dice","rollToLabel":"ogfxNa_rollToLabel","d10":"ogfxNa_d10","d8":"ogfxNa_d8","buttonsWrapper":"ogfxNa_buttonsWrapper","diceSetLabel":"ogfxNa_diceSetLabel","clearButton":"ogfxNa_clearButton","plus":"ogfxNa_plus"}
export default classes

const _gear0 = classes["gear"]
export { _gear0 as "gear" }

const _settingsButtonContainer0 = classes["settingsButtonContainer"]
export { _settingsButtonContainer0 as "settingsButtonContainer" }

const _wrapper0 = classes["wrapper"]
export { _wrapper0 as "wrapper" }

const _d200 = classes["d20"]
export { _d200 as "d20" }

const _d40 = classes["d4"]
export { _d40 as "d4" }

const _rollToActive0 = classes["rollToActive"]
export { _rollToActive0 as "rollToActive" }

const _shared3dDiceImageDisabled0 = classes["shared3dDiceImageDisabled"]
export { _shared3dDiceImageDisabled0 as "shared3dDiceImageDisabled" }

const _diceTextContainer0 = classes["diceTextContainer"]
export { _diceTextContainer0 as "diceTextContainer" }

const _rollToButton0 = classes["rollToButton"]
export { _rollToButton0 as "rollToButton" }

const _refreshText0 = classes["refreshText"]
export { _refreshText0 as "refreshText" }

const _shared3dDiceImage0 = classes["shared3dDiceImage"]
export { _shared3dDiceImage0 as "shared3dDiceImage" }

const _shared3dDiceImageWrapper0 = classes["shared3dDiceImageWrapper"]
export { _shared3dDiceImageWrapper0 as "shared3dDiceImageWrapper" }

const _rollButton0 = classes["rollButton"]
export { _rollButton0 as "rollButton" }

const _rollToContainer0 = classes["rollToContainer"]
export { _rollToContainer0 as "rollToContainer" }

const _rollToWrapper0 = classes["rollToWrapper"]
export { _rollToWrapper0 as "rollToWrapper" }

const _die0 = classes["die"]
export { _die0 as "die" }

const _d1000 = classes["d100"]
export { _d1000 as "d100" }

const _changeDiceSetLink0 = classes["changeDiceSetLink"]
export { _changeDiceSetLink0 as "changeDiceSetLink" }

const _shared3dDiceContainer0 = classes["shared3dDiceContainer"]
export { _shared3dDiceContainer0 as "shared3dDiceContainer" }

const _diceContainer0 = classes["diceContainer"]
export { _diceContainer0 as "diceContainer" }

const _dice0 = classes["dice"]
export { _dice0 as "dice" }

const _rollToLabel0 = classes["rollToLabel"]
export { _rollToLabel0 as "rollToLabel" }

const _d100 = classes["d10"]
export { _d100 as "d10" }

const _d80 = classes["d8"]
export { _d80 as "d8" }

const _buttonsWrapper0 = classes["buttonsWrapper"]
export { _buttonsWrapper0 as "buttonsWrapper" }

const _diceSetLabel0 = classes["diceSetLabel"]
export { _diceSetLabel0 as "diceSetLabel" }

const _clearButton0 = classes["clearButton"]
export { _clearButton0 as "clearButton" }

const _plus0 = classes["plus"]
export { _plus0 as "plus" }
